(function () {
  
  // FUNCTIONS
  async function getData() {
    const productId = document.querySelector(".store-availability-list").dataset
      .productId;
    const url = `https://bj-store-availability.modinity.workers.dev/?id=${productId}`;
    let result;
    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        result = data.data.productVariants.edges;
      });
    //console.log(result);
    return result;
  }

  function isPushed(name, data) {
    const hiddenStores = ["online store", "event - bazaar", "event - bsi jcc", "gaia pontianak"];
    return (
      !hiddenStores.includes(name.toLowerCase()) &&
      !data.some((store) => store.name === name)
    );
  }

  function cleanName(name) {
    return (
      name.replace("FC BS Store ", "Buttonscarves ")
      .replace("BS Store ", "Buttonscarves ")
      .replace("BS ", "Buttonscarves ")
      .replace("BJC ", "Benang Jarum Couture ")
      .replace("BJ ", "Benang Jarum ")
      .replace("Soetta", "Soekarno-Hatta")
      .replace("FC Benang Jarum", "Benang Jarum")
    );
  }

  function getAvailabilityStatus(quantity) {
    if (quantity > 3) return "Available";
    if (quantity > 0 && quantity <= 3) return "Low stock";
    if (quantity <= 0) return "Not available";
  }

  function isVariantAdd(name, data) {
    return (data.some((store) => store.name === name));
      //var result = data.find(item => item.name === name);
  }

  function addVariant(item, name, quantity, data) {
    var index = data.findIndex(store => store.name === name);
    const variant = {
      available_status: getAvailabilityStatus(quantity),
      quantity: quantity,
      title: item.node.title,
      id: item.node.id.replace("gid://shopify/ProductVariant/", "")
    }
    data[index].variants.push(variant);
    data[index].quantity = sumQuantity(quantity, data[index]);
    data[index].available = data[index].quantity > 0 ? true : false;
    data[index].available_status = getAvailabilityStatus(data[index].quantity);
    //console.log(name, data[index]);
  }

  function sumQuantity(variantQty, store) {
    return (store.quantity + variantQty);
  }



  function mutateData(result) {
    let data = [];

    result.forEach((item) => {
      const inventoryLevels = item.node.inventoryItem.inventoryLevels.edges;
      inventoryLevels.forEach((inventoryLevel) => {
        if (isPushed(inventoryLevel.node.location.name, data)) {
          const _data = {
            name: inventoryLevel.node.location.name,
            clean_name: cleanName(inventoryLevel.node.location.name),
            available:
              inventoryLevel.node.quantities[0].quantity > 0 ? true : false,
            available_status: getAvailabilityStatus(inventoryLevel.node.quantities[0].quantity),
            quantity: inventoryLevel.node.quantities[0].quantity,
            address: inventoryLevel.node.location.address.address1,
            phone: inventoryLevel.node.location.address.phone,
            variants: [
              {
                available_status: getAvailabilityStatus(inventoryLevel.node.quantities[0].quantity),
                quantity: inventoryLevel.node.quantities[0].quantity,
                title: item.node.title,
                id: item.node.id.replace("gid://shopify/ProductVariant/", "")
              }
            ]
          };
          data.push(_data);
        } else if (isVariantAdd(inventoryLevel.node.location.name, data)) {
          //console.log("udah ada");
          addVariant(item, inventoryLevel.node.location.name, inventoryLevel.node.quantities[0].quantity , data);
          //var result = data.find(item => item.name === name);
        }
      });
    });
    //console.log(data);
    return data;
  }

  // change object ada array variant
  //

  function toggleModal() {
    const modal = document.querySelector(".store-availability-modal");
    const body = document.querySelector("body");
    modal.dataset.modal = modal.dataset.modal == "open" ? "" : "open";
    modal.dataset.modal == "open"
      ? body.classList.add("stop-scrolling")
      : body.classList.remove("stop-scrolling");
  }

  function toggleAccordion(e) {
    const parent = this.parentNode;
    parent.dataset.accordion = parent.dataset.accordion == "open" ? "" : "open";   
  }

  function searchStore(e) {
    //console.log(e, e.currentTarget.value);
    const stores = document.querySelectorAll(".store-availability-store");
    stores.forEach(store => {
      if (store.dataset.store.toLowerCase().includes(e.currentTarget.value.toLowerCase())) {
        store.classList.remove("hidden");
      } else {
        store.classList.add("hidden");
      }
    });
  }

  function chatWhatsapp(store, phone, variant) {
    const product = document.querySelector(".store-availability-list").dataset.productTitle;
    const _variant = variant.toLowerCase() == "default title" ? '' : `- ${variant} `;
    const chat = `Halo ${store}, apakah ${product} ${_variant}masih tersedia? Terima kasih`;
    return (`https://wa.me/${phone}?text=${encodeURI(chat)}`);
  }

  function chatWhatsapp2(e) {
    e.preventDefault();
    
    const store = e.target.dataset.store;
    const phone = e.target.dataset.phone;
    const product = document.querySelector(".store-availability-list").dataset.productTitle;
    const firstVariant = document.querySelector(".store-availability-list").dataset.variantTitle;
    let variant = '';
    const data = JSON.parse(document.getElementById('variants-for-availability').textContent);
    
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    
    if (urlParams.has('variant')) {
      const variantId =  urlParams.get('variant');
      const index = data.findIndex(d => d.id == variantId);
      variant = `- ${data[index].title} `;
    } else if (firstVariant.toLowerCase() == "default title") {
      variant = '';
    } else {
      variant = `- ${firstVariant} `;
    }
      
    const chat = `Halo ${store}, apakah ${product} ${variant}masih tersedia? Terima kasih` 
    window.open(`https://wa.me/${phone}?text=${encodeURI(chat)}`);
  }

  function pickVariant(e) {
    e.target.dataset.state = "active";
    e.target.parentNode.querySelectorAll(`button:not([data-id='${e.target.dataset.id}'])`).forEach(button => { button.dataset.state = ""; });
    document.querySelectorAll(`.store-availability-store__status[data-id='${e.target.dataset.id}']`).forEach(el => { el.classList.remove("hidden"); });    
    document.querySelectorAll(`.store-availability-store__status:not([data-id='${e.target.dataset.id}'])`).forEach(el => { el.classList.add("hidden"); });    
    document.querySelectorAll(`.store-availability-store:has([data-id='${e.target.dataset.id}'])`).forEach(el => { el.classList.remove("hidden"); });  
    document.querySelectorAll(`.store-availability-store:not(:has([data-id='${e.target.dataset.id}']))`).forEach(el => { el.classList.add("hidden"); });   
  }

  // INIT
  function initStoreAvailability() {
    getData().then((result) => {
      const data = mutateData(result);
      const storeListEl = document.querySelector(".store-availability-list");
      let els = "";
  
      data.forEach((store) => {
        if (store.available) {
          let variantsEl = '';
          store.variants.forEach(variant => {
            if (variant.available_status != "Not available") {
              const title = variant.title.toLowerCase() == "default title" ? '' : `${variant.title} - `;
              variantsEl += `
                <div class="store-availability-store__status" data-available="${variant.available_status}" data-id="${variant.id}">
                  <div class="icon-dot"></div>
                  <span>${variant.available_status}</span> 
                  <a style="height: 24px;margin-right: 16px;" target=”_blank” href="${chatWhatsapp(store.clean_name, store.phone, variant.title)}">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.749 6.17972C15.3459 4.77481 13.4798 4.00071 11.4915 4C7.39433 4 4.05989 7.33409 4.05846 11.4323C4.05775 12.7424 4.40025 14.0211 5.05067 15.1481L3.99609 19L7.93641 17.9664C9.02198 18.5588 10.2444 18.8706 11.4883 18.871H11.4915C15.5879 18.871 18.9227 15.5365 18.9241 11.4383C18.9248 9.45217 18.1525 7.58499 16.749 6.18007V6.17972ZM11.4915 17.6158H11.489C10.3806 17.6154 9.29322 17.3174 8.3445 16.7547L8.11889 16.6207L5.78057 17.2341L6.40462 14.9542L6.25778 14.7204C5.63944 13.7368 5.31262 12.5998 5.31333 11.4327C5.31476 8.02657 8.0861 5.25523 11.494 5.25523C13.1441 5.25594 14.6951 5.89924 15.8616 7.06715C17.0281 8.2347 17.6699 9.78718 17.6692 11.4376C17.6678 14.8441 14.8965 17.6154 11.4915 17.6154V17.6158ZM14.8801 12.989C14.6944 12.896 13.7813 12.4469 13.6109 12.3849C13.4406 12.3229 13.3169 12.2919 13.1932 12.478C13.0696 12.664 12.7136 13.0824 12.6052 13.2061C12.4969 13.3301 12.3885 13.3454 12.2028 13.2524C12.0172 13.1594 11.4188 12.9634 10.7092 12.3307C10.1571 11.8382 9.78431 11.2302 9.676 11.0442C9.56764 10.8581 9.66459 10.7576 9.75723 10.6653C9.84062 10.5819 9.94292 10.4483 10.0359 10.3399C10.129 10.2316 10.1596 10.1539 10.2216 10.0302C10.2836 9.90619 10.2526 9.79787 10.2063 9.70482C10.16 9.61181 9.78862 8.69764 9.63358 8.32593C9.4828 7.96384 9.32958 8.01302 9.21588 8.00696C9.10753 8.00162 8.98388 8.00055 8.85985 8.00055C8.73582 8.00055 8.53479 8.04688 8.36445 8.23292C8.1941 8.41894 7.71438 8.86836 7.71438 9.78216C7.71438 10.696 8.37979 11.5795 8.4728 11.7035C8.56581 11.8275 9.78252 13.7033 11.6454 14.508C12.0884 14.6994 12.4345 14.8138 12.7043 14.8993C13.1491 15.0408 13.5539 15.0209 13.874 14.9731C14.2307 14.9196 14.9727 14.5237 15.1274 14.0899C15.2821 13.6562 15.2821 13.2841 15.2358 13.2068C15.1895 13.1294 15.0654 13.0827 14.8797 12.9897L14.8801 12.989Z" fill="#4A4A4A"/>
                    </svg>
                  </a>
                </div>
              `; 
            }
          })
          
          const el = `<div class="store-availability-store" data-available="${store.available_status}" data-store="${store.clean_name}">
              <div class="store-availability-store__header">
                <h3>${store.clean_name}</h3>
                <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 -960 960 960" width="28">
                  <path d="M480-361.693 258.693-583l39.73-39.73L480-441.153 661.577-622.73l39.73 39.73L480-361.693Z"/>
                </svg>
              </div>
              ${variantsEl}
              <div class="store-availability-store__accordion">
                <p>${store.address}</p>
                <p>${store.phone}</p>
                <div class="store-availability-store__link">
                  <a target=”_blank” href="http://maps.google.com/?q=${encodeURIComponent(store.clean_name)}">Maps</a>
                </div>
              </div>
              <hr>
            </div>`;
    
          els = els + el;
        }
      });
      storeListEl.innerHTML = els;
    }).then(() => {
      document.querySelectorAll(".store-availability-store__header").forEach(el => { el.addEventListener("click", toggleAccordion); });
      //document.querySelectorAll(".store-availability-store__status").forEach(el => { el.addEventListener("click", toggleAccordion); }); 
      document.querySelectorAll(".store-availability-store__whatsapp").forEach(el => { el.addEventListener("click", chatWhatsapp2); }); 
      document.querySelector(".store-availability-header__variant-picker button").click();
    });
  
    // EVENT LISTENERS
    document.querySelector(".store-availability-menu a").addEventListener("click", toggleModal);
    document.querySelector(".store-availability-menu a").dataset.event = "true";
    document.querySelector(".store-availability-dark").addEventListener("click", toggleModal);
    document.querySelector(".store-availability-header img").addEventListener("click", toggleModal);
    document.querySelector(".store-availability-header input").addEventListener("keyup", searchStore);
    document.querySelectorAll(".store-availability-header__variant-picker button").forEach(el => { el.addEventListener("click", pickVariant); }); 
  }

  initStoreAvailability();
  
  setInterval(() => {
    if (document.querySelector(".store-availability-menu a").dataset.event != "true") initStoreAvailability();
  }, 1000);

  // MUTATION OBSERVER
  
  
  // const callback = (mutationList, observer) => {
  //   console.log("msk");
  //   if (document.querySelector(".store-availability-menu a").dataset.event != "true") initStoreAvailability();
  //   for (const mutation of mutationList) {
  //     console.log("type", mutation.type);
  //     if (mutation.type === "attributes") {
  //       console.log(`The ${mutation.attributeName} attribute was modified.`);
  //       //initStoreAvailability();
  //     }
  //   }
  // };

  // //const targetNode = document.querySelector(".store-availability-menu a");
  // const targetNode = document.querySelector("[id^='MainProduct-template--']");
  // const config = { childList: true };
  // const observer = new MutationObserver(callback);
  // observer.observe(targetNode, config);

  
  
})();
